var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningCritical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_WARNING:_CRITICAL"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_WARNING:_CRITICAL",
    "data-name": "Icon_WARNING: CRITICAL",
    clipPath: "url(#clip-Icon_WARNING:_CRITICAL)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NOTIF._WARNING:_CRICTICAL",
    "data-name": "NOTIF. WARNING: CRICTICAL"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9602",
    "data-name": "Rechteck 9602",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7618",
    "data-name": "Pfad 7618",
    d: "M.94,11.979,12.437.874H27.9L39.016,11.979V27.771L27.9,39.373,12.437,38.88.94,27.771Z",
    transform: "translate(4 4)",
    fill: "#db0621"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_371",
    "data-name": "Pfad 371",
    d: "M2,27.455V12.543L12.544,2H27.456L38,12.543V27.455L27.456,38H12.544ZM11.716,0,0,11.715V28.283L11.716,40H28.284L40,28.283V11.715L28.284,0Z",
    transform: "translate(4 4)",
    fill: "#db0621"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_372",
    "data-name": "Pfad 372",
    d: "M26.605,11.979,20,18.584l-6.6-6.6L11.98,13.394,18.586,20,11.98,26.6,13.4,28.017l6.6-6.6,6.605,6.6L28.019,26.6l-6.6-6.6,6.6-6.6Z",
    transform: "translate(4 4)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningCritical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-critical.e1dd460daf833c0051ef679878d87e4e.svg";